var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("schedule")]
                      ),
                      _vm._v("\n          Ingestion Schedules\n        "),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        Manage job schedules and configuration assignments.\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        flat: "",
                        dark: "",
                        to: { name: "ingestionDashboard" },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v("Back to Dashboard\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      on: { click: _vm.openAdd },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
                      _vm._v("Add Schedule\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.schedules,
                  loading: _vm.loading,
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", [_vm._v(_vm._s(props.item.Name))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("code", [
                            _vm._v(_vm._s(props.item.CronExpression)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(props.item.CreatedAt))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "warning",
                                  depressed: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEdit(props.item)
                                  },
                                },
                              },
                              [_vm._v("Edit")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", color: "error" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(props.item)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500", persistent: "" },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.isEdit ? "Edit" : "Add") + " Schedule"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "v-form",
                    { ref: "form", attrs: { "lazy-validation": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Name",
                          rules: [_vm.rules.required],
                          required: "",
                        },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Cron Expression",
                          rules: [_vm.rules.required],
                          required: "",
                          hint: "5-field cron: minute hour day month weekday (e.g. 0 * * * *)",
                        },
                        model: {
                          value: _vm.form.CronExpression,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "CronExpression", $$v)
                          },
                          expression: "form.CronExpression",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.showDeleteDialog,
            callback: function ($$v) {
              _vm.showDeleteDialog = $$v
            },
            expression: "showDeleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "error" } },
                [_c("v-toolbar-title", [_vm._v("Confirm Delete")])],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", { staticClass: "pt-3" }, [
                _vm._v(
                  'Delete schedule "' +
                    _vm._s(_vm.deleteTarget ? _vm.deleteTarget.Name : "") +
                    '"?'
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "" },
                      on: {
                        click: function ($event) {
                          _vm.showDeleteDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "error" }, on: { click: _vm.doDelete } },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackColor, timeout: 6000, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }